import initialSyncfoniaState from "./phototool.initialState";
import pc9 from "./reducer/pc9";

const phototoolReducer = (state = initialSyncfoniaState, action) => {
  const reducers = {
    pc9
  };
  
  let { type } = action;
  if (reducers[type] === undefined) return state;
  
  return reducers[type](state, action);
};

export default phototoolReducer;
